import { ElioError } from '@elio/shared/models';
import { createAction, props } from '@ngrx/store';
import { JwtAccessTokenPaylaod } from '../../shared/src/lib/jwt/jwt-token.model';

const refreshJwtTokenSuccess = createAction(
  '[JwtToken Service] Refresh jwt token SUCCESS',
  props<{ jwtAccessToken: string; jwtAccessTokenPayload: JwtAccessTokenPaylaod }>()
);
const refreshJwtTokenFailure = createAction(
  '[JwtToken Service] Refresh jwt token FAILURE',
  props<{ error: ElioError }>()
);

export const JwtTokenActions = {
  refreshJwtTokenSuccess,
  refreshJwtTokenFailure,
};
